import { createLazyComponent, LazyAction, type LazyComponent, LazyModule } from "owa-bundling";
import type * as lazyIndex from "./lazyIndex";
import type { CopilotUpsellPaneProps } from "./components/CopilotUpsellPane.Props";

const lazyModule: LazyModule<typeof lazyIndex> = new LazyModule(() => import(/* webpackChunkName: "CopilotUpsellPane" */ "./lazyIndex"), { name: "CopilotUpsellPane" });

export const LazyCopilotUpsellPane: LazyComponent<CopilotUpsellPaneProps, undefined, null> = createLazyComponent(lazyModule, module => module.CopilotUpsellPane);

export const lazyRegisterCopilotUpsellEligibility: LazyAction<typeof lazyIndex.registerCopilotUpsellEligibility, typeof lazyModule> = new LazyAction(lazyModule, module => module.registerCopilotUpsellEligibility);

// Eager, lightweight read of the cached eligibility (no heavy gate graph).
export { getCopilotUpsellEligibility } from "./selectors/getCopilotUpsellEligibility";

export type { CopilotUpsellPaneProps };
